/* {% We want to use JavaScript only, because if it fails, customer can still checkout */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Constants
    const primaryCheckoutButton = {
      selector: 'div.cart__footer__checkout__buttons button[name="checkout"]',
      class: 'button--primary'
    }

    const secondaryCheckoutButton = {
      selector: 'div.cart__footer__checkout__buttons button[data-sso-login-id="login-button--checkout"]',
      class: 'button--inverse'
    }

    // Helper Functions
    function disableCheckoutButton(obj) {
      const button = document.querySelector(obj.selector);
      if (!button) return;

      button.classList.remove(obj.class);
      button.classList.add('button--disabled');
      button.disabled = true;
    }

    function enableCheckoutButton(obj) {
      const button = document.querySelector(obj.selector);
      if (!button) return;

      button.classList.add(obj.class);
      button.classList.remove('button--disabled');
      button.disabled = false;
    }

    function enableAllCheckoutButtons() {
      enableCheckoutButton(primaryCheckoutButton);
      enableCheckoutButton(secondaryCheckoutButton);
    }

    function disableAllCheckoutButtons() {
      disableCheckoutButton(primaryCheckoutButton);
      disableCheckoutButton(secondaryCheckoutButton);
    }

    // Handler
    function handleChange() {
      const isChecked = event.target.checked;
      if (isChecked) {
        enableAllCheckoutButtons();
      } else {
        disableAllCheckoutButtons();
      }
    }

    function resetCheckbox() {
      // Hack to handle delay in rendering
      setTimeout(function() {
        const checkbox = document.querySelector('input[name="checkout-agree-terms"]');
        checkbox.checked = false;
      }, 500);
    }

    function enableTermsCheckbox() {
      // Fix for Avada Order Limit app incorrectly disabling the terms checkbox
      // Using 500ms delay to ensure we run after the Avada app has finished
      setTimeout(function() {
        const checkbox = document.querySelector('input[name="checkout-agree-terms"]');
        if (checkbox) {
          checkbox.removeAttribute('disabled');
          checkbox.style.pointerEvents = '';
          checkbox.style.opacity = '';
        }
      }, 500);
    }

    // Main
    function init() {
      // Add event listener
      const input = document.querySelector('div.cart__footer__checkout__terms input[name="checkout-agree-terms"]');
      input.addEventListener('change', handleChange);

      // Disable checkout buttons on load
      disableAllCheckoutButtons();

      // Reset checkbox
      resetCheckbox();

      // Re-enable terms checkbox (fix for Avada Order Limit app)
      enableTermsCheckbox();
    }

    init();
  });
})();